import React from "react";
import parse from "html-react-parser";

const TableTrProductDescriptions = ({productDescriptions}) => {
    if (!(productDescriptions && Array.isArray(productDescriptions) && productDescriptions.length)) return null;

    return productDescriptions.map((item, index) => {
        return (
            <tr key={index}>
                <td colSpan="2" className="border-0"></td>
                <td colSpan="2" className="font-weight-normal text-left border-0 quotation-line-text">
                    {nl2br(parse(String(item?.description ?? '')))}
                </td>
                <td colSpan="2"></td>
            </tr>
        )
    });
}

function nl2br(text) {
    const lines = text.split('\n');
    return lines.map((line, index) => (
        <React.Fragment key={index}>
            {line}
            {index < lines.length - 1 && <br />}
        </React.Fragment>
    ));
}

export default TableTrProductDescriptions;
